// extracted by mini-css-extract-plugin
export var defaultWrapper = "_jg-3";
export var downloadButton = "_jg-4";
export var fileContainer = "_jg-9 _jg-7";
export var fileContainerBase = "_jg-7";
export var fileContainerFixedHeight = "_jg-8 _jg-7";
export var fileInfo = "_jg-5";
export var fileInfoWidthRestricted = "_jg-6";
export var fileType = "_jg-1";
export var fileTypeName = "_jg-2";
export var image = "_jg-0";
export var link = "_jg-b";
export var overflowEllipsis = "_jg-a";